import { render, staticRenderFns } from "./FeedbackEntry.vue?vue&type=template&id=21bdd17f&scoped=true"
import script from "./FeedbackEntry.vue?vue&type=script&lang=js"
export * from "./FeedbackEntry.vue?vue&type=script&lang=js"
import style0 from "./FeedbackEntry.vue?vue&type=style&index=0&id=21bdd17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bdd17f",
  null
  
)

export default component.exports